if(!customElements.get('simple-tabs')) {
  class ComponentSimpleTabs extends HTMLElement {
    constructor() {
      
      super();

      this.buttons = this.querySelectorAll('.tab-button');
      this.tabs = this.querySelectorAll('.tab');

      if(this.buttons.length > 0 && this.tabs.length > 0){
        this.selectedButton = this.buttons[0]
        this.selectedTab = this.tabs[0]

        this.buttons.forEach( button => {
          button.addEventListener('click', ()=>{
            if (this.selectedButton != button){
              this.selectedButton.classList.remove('selected');
              this.selectedButton = button;
              this.selectedButton.classList.add('selected');

              this.selectedTab.classList.add('hidden');
              this.tabs.forEach(tab => {
                const tabClass = 'tab-' +  button.dataset.tabIndex;

                if(tab.dataset.tab == tabClass){
                  this.selectedTab = tab;
                  this.selectedTab.classList.remove('hidden');
                }
              })
            }
          })
        })
      }

    }


  }
  customElements.define('simple-tabs', ComponentSimpleTabs);
}